import { SubscriptionContactInfoComponent } from '../my-vehicle/manage-subscription/subscription-contact-info/subscription-contact-info.component';
import { PaymentCardComponent } from './../payment/payment-options/payment-card/payment-card.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ManagerDriversDialogComponent } from './manager-drivers-dialog/manager-drivers-dialog.component';
import { TelematicsPackageFeaturesDialogComponent } from './telematics-package-features-dialog/telematics-package-features-dialog.component';
import { SeviceItemComponentComponent } from '../my-vehicle/trials/unlock-features/sevice-item-component/sevice-item-component.component';
import { PackageDemoDialogComponent } from './package-demo-dialog/package-demo-dialog.component';
import { ResetPinDialogComponent } from './reset-pin-dialog/reset-pin-dialog.component';
import { SetDefaultConfirmationComponent } from './setDefault-Popup/set-default-confirmation.component'
import { ToggleAutoRenewalDialogComponent } from './toggle-auto-renewal-dialog/toggle-auto-renewal-dialog.component';
import { CancelTrialConfirmationDialogComponent } from './cancel-trial-confirmation-dialog/cancel-trial-confirmation-dialog.component';
import { CancelSubscriptionDialogComponent } from './cancel-subscription-dialog/cancel-subscription-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { CancelSubscriptionConfirmationDialogComponent } from './cancel-subscription-confirmation-dialog/cancel-subscription-confirmation-dialog.component';
import { LinkPackageFeatureDialogComponent } from './link-package-feature-dialog/link-package-feature-dialog.component';
import { FooterComponentComponent } from './footer-component/footer-component.component';
import { EditSubscriptionContactInfoComponent } from '../my-vehicle/vehicle-detail/edit-subscription-contact-info/edit-subscription-contact-info.component';
import { MatStepperModule } from '@angular/material/stepper';
import { SelectSubscriptionComponent } from '../my-vehicle/manage-subscription/select-subscription/select-subscription.component';
import { SubscriptionItemComponent } from '../my-vehicle/manage-subscription/select-subscription/subscription-item/subscription-item.component';
import { SubscriptionPaymentMethodComponent } from '../my-vehicle/manage-subscription/subscription-payment-method/subscription-payment-method.component';
import { MatIconModule } from '@angular/material/icon';
import { SubscriptionCreatePinComponent } from '../my-vehicle/manage-subscription/subscription-create-pin/subscription-create-pin.component';
import { SubscriptionSummaryComponent } from '../my-vehicle/manage-subscription/subscription-summary/subscription-summary.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BraintreeIntegrationComponent } from '../payment/braintree-integration/braintree-integration.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LoaderComponent } from './loader/loader.component';
import { ChangeVehcileComponent } from './change-vehcile/change-vehcile.component';
import { ViewInvoiceComponent } from '../payment/account-billing-hostory/view-invoice/view-invoice.component';
import { SafeHtmlPipe } from './pipe/safehtml.pipe';
import { MaskPhoneDirective } from './Models/mask-phone.directive';
import { SelectCancelSubscriptionDialogComponent } from './select-cancel-subscription-dialog/select-cancel-subscription-dialog.component';
import { CancelSubscriptionInformationDialogComponent } from './cancel-subscription-information-dialog/cancel-subscription-information-dialog.component';
import { CancelSubscriptionItemComponent } from './select-cancel-subscription-dialog/cancel-subscription-item/cancel-subscription-item.component';
import { AddPaymentRequiredDialogComponent } from './addPayment-reuired-dialog/add-payment-required-dialog.component'
import { InfoPopUpComponent } from './info-popup/info-popup.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { RemoveCardConfirmationDialogComponent } from './remove-card-confirmation-dialog/remove-card-confirmation-dialog.component';
import { CardRemovedDialogComponent } from '../shared/card-removed-dialog/card-removed-dialog.component';
import { RemoveCardAfterAddDialogComponent } from '../shared/removeCard-afterAdd/remove-card-after-add-dialog.component';
import { provideTranslateService, TranslateModule } from '@ngx-translate/core';
import { QRCodeComponent } from 'angularx-qrcode';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';


@NgModule({
  declarations: [
    PaymentCardComponent,
    ManagerDriversDialogComponent,
    TelematicsPackageFeaturesDialogComponent,
    SeviceItemComponentComponent,
    PackageDemoDialogComponent,
    ResetPinDialogComponent,
    ToggleAutoRenewalDialogComponent,
    CancelTrialConfirmationDialogComponent,
    CancelSubscriptionDialogComponent,
    CancelSubscriptionConfirmationDialogComponent,
    LinkPackageFeatureDialogComponent,
    FooterComponentComponent,
    SubscriptionContactInfoComponent,
    EditSubscriptionContactInfoComponent,
    SelectSubscriptionComponent,
    SubscriptionItemComponent,
    SubscriptionPaymentMethodComponent,
    SubscriptionCreatePinComponent,
    SubscriptionSummaryComponent,
    BraintreeIntegrationComponent,
    LoaderComponent,
    ChangeVehcileComponent,
    ViewInvoiceComponent,
    SafeHtmlPipe,
    MaskPhoneDirective,
    //cancel sub ui
    SelectCancelSubscriptionDialogComponent,
    CancelSubscriptionInformationDialogComponent,
    CancelSubscriptionItemComponent,
    InfoPopUpComponent,
    SetDefaultConfirmationComponent,
    AddPaymentRequiredDialogComponent,
    CardRemovedDialogComponent,
    RemoveCardConfirmationDialogComponent,
    RemoveCardAfterAddDialogComponent
  ],
  exports: [
    PaymentCardComponent,
    SeviceItemComponentComponent,
    FooterComponentComponent,
    PaymentCardComponent,
    ManagerDriversDialogComponent,
    TelematicsPackageFeaturesDialogComponent,
    SeviceItemComponentComponent,
    PackageDemoDialogComponent,
    ResetPinDialogComponent,
    ToggleAutoRenewalDialogComponent,
    CancelTrialConfirmationDialogComponent,
    CancelSubscriptionDialogComponent,
    CancelSubscriptionConfirmationDialogComponent,
    LinkPackageFeatureDialogComponent,
    SubscriptionContactInfoComponent,
    EditSubscriptionContactInfoComponent,
    MatStepperModule,
    MatIconModule,
    SelectSubscriptionComponent,
    SubscriptionItemComponent,
    SubscriptionPaymentMethodComponent,
    SubscriptionCreatePinComponent,
    SubscriptionSummaryComponent,
    MatCheckboxModule,
    LoaderComponent,
    ChangeVehcileComponent,
    SafeHtmlPipe,
    MaskPhoneDirective,
    TranslateModule
  ], imports: [CommonModule,
    SharedRoutingModule,
    MatButtonModule,
    MatRadioModule,
    MatStepperModule,
    MatIconModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatDialogModule,
    TranslateModule,
    QRCodeComponent
  ],
  providers: [provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'en-US',
      lang: 'en-US',
    }),
  ]
})
export class SharedModule { }
